import type { ReactNode } from 'react'
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'

type PackagingAssessmentRunDetailSheetProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  children: ReactNode
}

export function PackagingAssessmentRunDetailSheet({
  open,
  onOpenChange,
  title,
  children,
}: PackagingAssessmentRunDetailSheetProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side='right'
        className='flex h-full w-full flex-col gap-0 overflow-hidden p-0 sm:max-w-3xl'
      >
        <SheetHeader className='shrink-0 border-b px-6 py-4 pe-10 text-start'>
          <SheetTitle>{title}</SheetTitle>
        </SheetHeader>
        <div className='min-h-0 flex-1 overflow-y-auto px-6 py-4'>
          {children}
        </div>
      </SheetContent>
    </Sheet>
  )
}
